import { AuthLayout, VerifyOtpForm } from '../components';
import Homescreen_icon from '../../home/assets/Homescreen.png';
import { AUTH_TITLE_CLASS, AUTH_SUBTITLE_CLASS } from '../lib/authStyles';

export function VerifyOtpPage() {
  return (
    <AuthLayout rightImage={Homescreen_icon} rightAlt="Aexon Assistant Mockup">
      <h1 className={AUTH_TITLE_CLASS}>Verify Your OTP</h1>
      <h2 className={AUTH_SUBTITLE_CLASS}>
        Enter the 6-digit code sent to your email or phone
      </h2>

      <div className="animate-fadeIn">
        <VerifyOtpForm />
      </div>
    </AuthLayout>
  );
}
